<div class="padding">
  <div class="box">
    <div [gp-stick-between]="{top:64}" class="box-header white">
      <div class="row">
        <div class="pull-left box-title">
          <h3>{{'ACCOUNTING.ACCOUNTING_PLAN_MAPPING.tile' | translate }}</h3>
        </div>
      </div>
    </div>

    <div class="box-body body-height">
      <div class="text-right">
        <button (click)="addNewAccountingPlan()"
                class="btn white no-borders btn-add"
                placement="left"
                tooltip="{{ 'TOOLTIPS.add_entry' | translate }}"
                [disabled]="!canAddBtnBeEnabled()"
                type="button">
          <i aria-hidden="true" class="fa fa-light fa-plus"></i>
        </button>
      </div>
      <form [formGroup]="accountingPlanForm" class="table-wrapper">
        <div aria-labelledby="caption" role="region" tabindex="0">
          <table aria-describedby="accountingPlanList"
                 class="table table-striped gp-table accounting-mapping-management-table"
                 id="ventilation">
            <thead class="headers white accounting-mapping-management-table-header-sticky-top">
              <tr role="row">
                <th class="text-sm w-150 pointer" scope="col" test-id="nameCol">
                  {{ 'MENU.CONFIGURATION.accounting.plan.name' | translate }}
                </th>

                <th class="text-sm w-310 pointer" scope="col" test-id="accountCol">
                  {{ 'MENU.CONFIGURATION.accounting.plan.payserie' | translate }}
                </th>
                <th class="text-sm w-400 pointer" scope="col" test-id="payArrayCol" *ngIf="isAccountantAdmin">
                  {{ 'MENU.CONFIGURATION.accounting.plan.payArray' | translate }}
                </th>
                <th class="text-sm w-96 pointer" scope="col" test-id="actionCol"></th>
              </tr>
            </thead>

            <tbody #tableBody formArrayName="accountingPlans">
              <tr *ngIf="isAccountingPlanLoading||saveInProgress">
                <td [attr.colspan]="isAccountantAdmin? 4:3 " class="text-center p-t-lg p-b-lg">
                  <i class="fa fa-light fa-spinner fa-spin" aria-hidden="true"></i>
                </td>
              </tr>

              <tr (click)="editCell(group.value, planIndex)"
                  *ngFor="let group of accountingPlan.controls; let planIndex=index"
                  [attr.test-id]="'row' + planIndex"
                  [formGroupName]="planIndex">

                <td>
                  <div (click)="editCell(group.value, planIndex)" *ngIf="!group.get('editMode').value">
                    {{group.get('name').value}}
                    <span *ngIf="!group.get('name').value">-</span>
                  </div>

                  <div [attr.data-hidden]="!group.get('editMode').value">
                    <input [attr.test-id]="'name' + planIndex"
                           class="form-control"
                           formControlName="name"
                           [id]="'name' + planIndex"
                           type="text" #accountingPlanNameInput>
                    <ul [attr.data-hidden]="group.get('name').valid" class="error-list">
                    </ul>
                  </div>
                </td>
                <td (click)="editCell(group.value, planIndex)" class="payserie-cell">
                  <gp-chips [readOnly]="!group.get('editMode').value"
                            [formControlName]="'paySeries'"
                            [placeholder]="'ACCOUNTING.ACCOUNTING_PLAN_MAPPING.choose_payserie'"
                            [withAutocomplete]="true"
                            [displayBy]="'transId'"
                            [identifyBy]="'id'"
                            (filterOptions)="filterPaySeriesBasedOnInput(($event))">
                    <gp-chips-option *ngFor="let option of getUnSelectedPaySeries()"
                                     [ngValue]="option"
                                     class="payserie-options">
                    </gp-chips-option>
                  </gp-chips>
                </td>
                <td (click)="editCell(group.value, planIndex)" class="pay-array-cell" *ngIf="isAccountantAdmin">
                  <gp-chips [placeholder]="'MENU.CONFIGURATION.accounting.plan.payArray'" [withAutocomplete]="true"
                            [formControlName]="'payArrayNames'"
                            [readOnly]="!group.get('editMode').value"
                            (filterOptions)="filterPayArraysBasedOnInput(($event))"
                            [modelAsString]="true"
                            [canAddNewTags]="true"
                            [showTooltip]="true">
                    <gp-chips-option *ngFor="let option of filteredPayArrayNames" [ngValue]="option"></gp-chips-option>
                  </gp-chips>
                </td>

                <td>
                  <div class="btn-bar-wrapper pull-right">
                    <div class="btn-bar btn-bar-sm">
                      <a
                         (click)="editAccountingPlan($event, group.value)"
                         class="btn btn-sm btn-icon white"
                         *ngIf="group?.value?.id"
                         [routerLink]="['rules', group?.value?.id]"
                         [queryParams]="{
                           readOnly: false,
                           cliRegIds: cliRegIdsToString()
                         }"><i aria-hidden="true" class="far fa-edit"></i></a>

                      <button (click)="deleteAccountingPlan($event,planIndex, group.value)"
                              class="btn btn-sm btn-icon white"
                              container="body"
                              placement="left"
                              tooltip="{{ 'TOOLTIPS.delete_entry' | translate }}"
                              type="button">
                        <i aria-hidden="true" class="fa fa-light fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </form>
      <gp-illustrated-message
        *ngIf="!isAccountingPlanLoading && !initialAccountingPlans?.length && !accountingPlan?.length"
        [text]="'ACCOUNTINGPLAN.no_accountingPlan'"
        [width]="'50%'">
      </gp-illustrated-message>
      <footer [gp-sticky]="'bottom'" [refreshOn]="dataLoaded" class="dker p-a">
        <div class="row">
          <div class="col-sm-12 text-center text-center-xs">
            <ul class="pagination pagination-sm gp-pagination m-a-0" [class.gp-pagination-hidden]="!pagination.hasMultiplePages()">
              <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
                <a (click)="pagination.hasPrevious() && pagination.first()" class="page-link">
                  <i aria-hidden="true" class="fa fa-light fa-angle-double-left"></i>
                </a>
              </li>
              <li [ngClass]="{disabled: !pagination.hasPrevious()}" class="page-item">
                <a (click)="pagination.hasPrevious() && pagination.previous()" class="page-link">
                  <i aria-hidden="true" class="fa fa-light fa-angle-left"></i>
                </a>
              </li>

              <li *ngFor="let page of pagination.pages()" class="page-item"
                  [ngClass]="{active: page === pagination.currentPage.number + 1, disabled: page < 1}">
                <a *ngIf="page > 0" (click)="pagination.goToPage(page - 1)" class="page-link">{{ page }}</a>
                <a *ngIf="page < 1" class="page-link default-cursor">…</a>
              </li>
              <li [ngClass]="{disabled: !pagination.hasNext()}" class="page-item">
                <a (click)="pagination.hasNext() && pagination.next()" class="page-link">
                  <i aria-hidden="true" class="fa fa-light fa-angle-right"></i>
                </a>
              </li>
              <li [ngClass]="{disabled: !pagination.hasNext()}" class="page-item">
                <a (click)="pagination.hasNext() && pagination.last()" class="page-link">
                  <i aria-hidden="true" class="fa fa-light fa-angle-double-right"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </footer>
    </div>
  </div>
</div>
